import React from 'react';
import {
  Box, Divider, TextField, Typography,
} from '@mui/material';
import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import ButtonPrimary from '../ButtonPrimary';
import useForm from './useForm';
import useBankAccounts from '../../resources/bankAccounts/read';
import AutoPayTermsAndConditions from '../AutoPayTermsAndConditions';

const SelectBankAccount = () => {
  const { data: bankAccounts } = useBankAccounts();
  const {
    handleSubmit,
    isLoading,
    control,
  } = useForm();

  return (
    <>
      <Box
        component="form"
        onSubmit={handleSubmit}
      >
        <ValidatedTextField
          name="selectedBankAccountId"
          control={control}
          defaultValue={bankAccounts.at(-1)?.id || ''} // default to most recently added
          rules={{ required: 'This field is required.' }}
        >
          <TextField
            fullWidth
            label="Pay From Account"
            select
            SelectProps={{ native: true }}
          >
            <option value="" disabled aria-label="blank option" />
            {bankAccounts.map((account) => (
              <option key={account.id} value={account.id}>{account.attributes.name}</option>
            ))}
          </TextField>
        </ValidatedTextField>
        <AutoPayTermsAndConditions />
        <Typography variant="caption" textAlign="center" color="black">
          By clicking “Connect Your Bank”, you&apos;re agreeing to the
          autopay terms and conditions shown above.
        </Typography>
        <ButtonPrimary isLoading={isLoading}>
          Connect Bank Account
        </ButtonPrimary>
      </Box>
      <Divider>OR</Divider>
    </>
  );
};

export default SelectBankAccount;
